// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/footer/footer.scss
 ** module id = 85
 ** module chunks = 0 1
 **/